/* eslint eqeqeq: "off" */
import React from 'react';
import toastr from 'toastr';
import moment from 'moment';
import 'moment/locale/es';
import {findObjectByKey} from '../../util/index';
import { Icon, Label,Input, Button, Checkbox, Dropdown,Menu, Table,Header, Modal, Segment, Popup } from 'semantic-ui-react'
import {connect} from 'react-redux';
import * as tablasActions from '../../actions/tablasActions';
import { DateRangePicker } from 'react-dates';
import {bindActionCreators} from 'redux';
import { DatePicker, Space } from 'antd';
import ModalPlay from './ModalPlay';
import { Link } from "react-router-dom";
import locale from 'antd/es/date-picker/locale/es_ES';
//import "antd/dist/antd.css";
const dateFormat = 'DD/MM/YYYY';

moment.locale('es');

const { RangePicker } = DatePicker; 




class ManageTabla extends React.Component {
	
	constructor(props, context) {
        super(props, context);	
		this.state = {
            currentPlay:{},
            showModalPlay:false,
            revisionInicio:new moment(),
            revisionFin:new moment(),
            focusedInicio:false,
		 nuevo:{
             fecha2:new moment()
         },
         rows:[],
            showModal:false
            
             
		};
		
		
	}
    
    static  getDerivedStateFromProps(props, state){
        
        if(state.rows.length==0 && props.tablas.length>0){
            let tabla=[...props.tablas.filter(tabla => tabla.nombre == props.nombre)];   
            if(tabla.length>0){
                return{"rows": tabla[0].rows};
            }
        }
        return null;
    }
    
    
     componentWillReceiveProps(nextProps) {	
        
        //console.log("componentWillReceiveProps");
        // //console.log(nextProps.test);
        // //console.log(this.props.test);
	}
    
    componentDidMount(){
        let tabla=[...this.props.tablas.filter(tabla => tabla.nombre == this.props.nombre)];   
        
        console.log(this.props);
        
        if(tabla.length>0){
            this.setState({"rows": tabla[0].rows});
        }else{
            let rows=[];
            this.setState({"rows": rows});
        }
        
    }

    
    editRow =(id)=>{
        let newState=Object.assign([], this.state.rows);
        newState=[...newState.filter(row => row.id == id)];   
        //console.log(newState[0]);
        
        this.setState({"nuevo":Object.assign({}, newState[0])});
        
    }
    
    viewRow=(id)=>{
         let newState=Object.assign([], this.state.rows);
            newState=[...newState.filter(row => row.id == id)];  
        
        this.props.infoActions.getContenidoDetalle(newState[0].id, this.props.user).then( (contenido)=>{
              
                this.setState({"showModalPlay":true,
                      "currentPlay":contenido});
        })
        .catch(error=>{
          toastr.error(error);
        }); 
        
        
        
        
    }
    
    closeModalPlay=()=>{
        this.setState({"showModalPlay":false});
    }
    
    
    removeRow =(id)=>{
         let newState=Object.assign([], this.state.rows);
            newState=[...newState.filter(row => row.id !== id)];   
        this.setState({"rows":newState});
        this.actualizaActions(newState);
    }
    
    
    reset=()=>{
       let nuevo={};
        
        this.props.campos.map(campo=>
            nuevo[campo]=""                     
        );
        this.setState({
                      "nuevo":nuevo
                      });
    }
    

    addRow=()=>{
        let rows= this.state.rows;
        let nuevo=this.state.nuevo;
        
        let fechaInicio=Object.assign({},this.state.revisionInicio);
        let fechaFin=Object.assign({},this.state.revisionFin);
        let fecha2=Object.assign({},nuevo.fechasArreglo);
        if(nuevo.id==null || nuevo.id==0){
            nuevo.id=Number(new Date())*-1;
        }else{
            rows=[...rows.filter(row => row.id !== nuevo.id)];
        }
        
        nuevo.fechaInicio=new moment(fechaInicio);
        nuevo.fechaFin=new moment(fechaFin);
        nuevo.fecha2=new moment(fecha2);
        
        
        
        rows.push(nuevo);
        
        //console.log(rows);
        
        nuevo={};
        this.props.campos.map(campo=>
            nuevo[campo]=""                     
        );
        nuevo.fecha2=new moment();
        
        
        this.setState({"rows":rows,
                      "nuevo":nuevo
                      });
        this.actualizaActions(rows);
    }
    
    validar=(val, value)=>{
        if(val.type=="String"){
            if(val.length && val.length>0){
                if(value.length>val.length){
                    toastr.warning("Longitud máxima permitida en el campo.");
                    return false;
                }
            }
        }
        
        if(val.type=="int"){
            if(isNaN(value)){
                toastr.warning("Debes ingresar datos numericos.");
                return false;
            }
            
            if(value<val.min || value>val.max){
                toastr.warning("Valor fuera de rango.");
                return false;
            }
        }
        
    
        
        
        return true;
        
    }
    
    handleChange=(event, data, id)=> {	
    
        
        let field= data.name;		
        let value=	data.value;		
                                 
        let nuevo=this.state.nuevo;   
        
        let validaciones=this.props.validaciones;
         
        if(validaciones){
            let val=[...validaciones.filter(val => val.name== field)];
            if(val.length>0){
                val=val[0];
                if(!this.validar(val, value)){
                    if(!nuevo[field]){
                        nuevo[field]="";
                    }
                    this.setState({"nuevo": nuevo});
                    return;
                }
            }
        }
        
         if(data.toggle){
            //es un check
            if(data.checked){
                value=	1;
            }            
            else{
                value=	2;
            }
        }
        
        if(field=='idContenido'){
            
            let tipo = this.props.contenidoComboTipo.filter(cont => cont.id == value);
            //console.log(tipo);
            if(tipo[0].id2==Number(28)){
                this.state.showModal=true;
                
                //console.log("abrir ventana");
            }
        }
        

        field = field.split('.');
        if (field.length == 1)
            nuevo[field[0]] = value;
        else{
             if(!nuevo[field[0]]){
                    nuevo[field[0]]={}
                }
                nuevo[field[0]][field[1]] = value;
            }
        
		
        this.setState({"nuevo": nuevo});
        //console.log(nuevo);
         
    }
    
    getDescripcion=(id)=>{
        let valor=[...this.props.combo.filter(row => row.key == id)]; 
        if(valor.length>0)
        {
                return valor[0].text;
        }
        return "";
    }
    
    getDescripcionUsuario=(id)=>{
        if(this.props.comboInstructor!=null){
           let valor=[...this.props.comboInstructor.filter(row => row.key == id)]; 
            if(valor.length>0)
            {
                    return valor[0].text;
            } 
            
        }
        
        return "";
    }

    actualizaActions=(rows)=>{
        let tabla={
            "nombre":this.props.nombre,
            "rows":rows
        };
        this.props.tablasActions.update(tabla);
        
    }
    
    
    onDatesChange=(startDate, endDate )=>{
        this.setState({"revisionInicio": startDate,"revisionFin": endDate});
    }
    
    onFocusChangeInicio=(focusedInput)=>{
        this.setState({ "focusedInicio":focusedInput });
    }
    
    closeModal=()=>{
        this.setState({showModal:false});
        //console.log("cerrando ventana");
    }
    
    fechas=(fechasArreglo, fechasCadena)=>{
         let nuevo=this.state.nuevo;
        nuevo.fechasArreglo= fechasArreglo;
        nuevo.fechasCadena = fechasCadena;
        if(fechasArreglo.length>0){
            //nuevo.fechaInicioExamen=fechasArreglo[0].format('YYYY/MM/DD HH:mm:ss');
            //nuevo.fechaTerminoExamen=fechasArreglo[1].format('YYYY/MM/DD HH:mm:ss');
            nuevo.fechaInicioExamen=fechasArreglo[0].format("DD-MM-YYYY HH:mm");
            nuevo.fechaTerminoExamen=fechasArreglo[1].format("DD-MM-YYYY HH:mm");;
        }
        this.setState({nuevo:nuevo});
        
    }
    
    
    fecha=(fechas, fechasCadena)=>{
       
        
        let nuevo=this.state.nuevo;
        nuevo.fechasArreglo= fechas;
        nuevo.fechasCadena = fechasCadena;
            //console.log("entro");
            //console.log(fechas);
            //nuevo.fechaInicioExamen=fechasArreglo[0].format('YYYY/MM/DD HH:mm:ss');
            //nuevo.fechaTerminoExamen=fechasArreglo[1].format('YYYY/MM/DD HH:mm:ss');
            nuevo.fecha2=nuevo.fechasArreglo.format('YYYY/MM/DD HH:mm:ss');
        
            //console.log(nuevo.fecha2);
        
        this.setState({nuevo:nuevo});
        
    }
    
    render() {	
		return (
            <Segment>
            
            <Table celled>
                <Table.Header>
                  <Table.Row>
            
                    {this.props.headers.map(row=>
                        <Table.HeaderCell textAlign="center">{row}</Table.HeaderCell>
                    )}   
                        <Table.HeaderCell textAlign="center"></Table.HeaderCell>
                  </Table.Row>
                </Table.Header>

                <Table.Body>
                  <Table.Row>        
                      {this.props.campos.map((campo, id)=>
                       <Table.Cell>
                       {this.props.tipoTablaModulos[id]=="combo"?
                       <Dropdown                                       
                            placeholder='Selecciona una opción'
                            fluid
                            search
                            onChange={this.handleChange}
                            selection
                            options={campo=="idContenido"||campo=="idModulo"?this.props.combo:this.props.comboInstructor}
                            name={campo}
                            value={this.state.nuevo[campo]}
                            />   
                       
                       :""}
                       {this.props.tipoTablaModulos[id]=="input"?
                           <Input 
                            name={campo}
                            value={this.state.nuevo[campo]}
                            onChange={this.handleChange}
                            />
                        :""}
                        {this.props.tipoTablaModulos[id]=="Checkbox"?
                           <Checkbox name={campo}
                                value={this.state.nuevo[campo]}
                                onChange={this.handleChange}
                                toggle label='Gratuito' />
                             
                        :""}

                        {this.props.tipoTablaModulos[id]=="button"?
                         
                        ""    
                        :""}


                        {this.props.tipoTablaModulos[id]=="date"?
                           <DateRangePicker
                                    
                                isOutsideRange={() => false}
                                withPortal 
                                startDate={this.state.revisionInicio} // momentPropTypes.momentObj or null,
                                startDateId="revisionInicio" // PropTypes.string.isRequired,
                                endDate={this.state.revisionFin} // momentPropTypes.momentObj or null,
                                endDateId="revisionFin" // PropTypes.string.isRequired,
                                onDatesChange={({ startDate, endDate }) => this.onDatesChange(startDate, endDate )}

                                focusedInput={this.state.focusedInicio} // PropTypes.bool
                                onFocusChange={(focusedInput)=>this.onFocusChangeInicio(focusedInput)} // PropTypes.func.isRequired

                                    displayFormat="DD-MM-YYYY"

                                    showDefaultInputIcon 
                                    inputIconPosition="after" 

                                /> 
                        :""}

                        {this.props.tipoTablaModulos[id]=="sigleDate"?
                            
                            <DatePicker 
                                    //defaultValue={moment(this.state.nuevo.fecha2)}    
                                    bordered={false}
                                    onChange={(dates, dateStrings)=>this.fecha(dates, dateStrings)} 
                                    locale={locale} 
                                    size="large" 
                                    value={moment(this.state.nuevo.fecha2)}
                                    allowClear={false}
                                    format={dateFormat} />
                            
                        
                        :""}

                       </Table.Cell>
                       )}
                    <Table.Cell textAlign="center"> 
                            <Icon name='add circle' size='large' onClick={this.addRow} link color="green" />
                            <Icon name='trash alternate outline' size='large' onClick={this.reset} link color="red" />
                                
                            </Table.Cell>  
                  </Table.Row>    
                 
                    {this.state.rows.map(row=>
                        <Table.Row>
                        {this.props.campos.map((campo, id)=>
                                <Table.Cell>
                                {this.props.tipoTablaModulos[id]=="combo"?
                                    <>
                                    {campo=="idContenido"||campo=="idModulo"?
                                        this.getDescripcion(row[campo])
                                           
                                    :
                                        this.getDescripcionUsuario(row[campo])  
                                    }
                                    </>
                                :""}
                                         
                                {this.props.tipoTablaModulos[id]=="button"?
                                    <>
                                    {campo=="idModulo"?
                                         
                                         <Popup
                                            trigger={<Icon  name='cog' link onClick={()=>this.props.verModulo(row.idModulo)}  size="large"  color="tela" ></Icon>}
                                            content={'Editar Módulo'}

                                          />
                                        
                                        :
                                    ""}
                                         
                                    {campo=="idContenido"?
                                        <Link to={"/contenido/"+row.idContenido}> 
                                         <Popup
                                            trigger={<Icon  name='cog' link   size="large"  color="tela" ></Icon>}
                                            content='Editar Contenido'

                                          />
                                         </Link> 
                                        :
                                    ""}     
                                    </>    
                                             
                                :""}         
                                         
                                {this.props.tipoTablaModulos[id]=="input"?
                                    
                                    row[campo]  
                                        
                                             
                                :""}
                                         
                                {this.props.tipoTablaModulos[id]=="Checkbox"?
                                         <div>{row[campo]==1?"Si":"No"}   </div>    
                                :""}
                                         
                                {this.props.tipoTablaModulos[id]=="date" && moment.isMoment(row["fechaInicio"])?
                                   "Periodo: "+ row["fechaInicio"].format("DD-MMM-YYYY")+ " / "+ row["fechaFin"].format("DD-MMM-YYYY")    
                                :""}       
                    
                                 {this.props.tipoTablaModulos[id]=="sigleDate" && moment.isMoment(row["fecha2"])?
                                    row["fecha2"].format("Do  MMMM")
                                :""}       

                                </Table.Cell>
                            
                            
                        )}

                        <Table.Cell textAlign="center"> 
                            {this.props.play==true? 
                             
                                <Icon name='play circle' size='large' onClick={()=>this.viewRow(row.id)} link color="green" />
                            :""}
                            <Icon name='remove' size='large' onClick={()=>this.removeRow(row.id)} link color="red" />
                            <Icon name='edit outline' size='large' onClick={()=>this.editRow(row.id)} link color="blue" />    
                        </Table.Cell> 
                        </Table.Row>
                     )}
                  
                </Table.Body>
            </Table>
            
              <ModalPlay 
                    showModal={this.state.showModalPlay}
                    closeModal={this.closeModalPlay}
                    datos={this.state.currentPlay}
                />
              <Modal open={this.state.showModal}  size='small'>
                <Header  />
                <Modal.Content>
                  
                  <RangePicker bordered={true} locale={locale} onChange={(dates, dateStrings)=>this.fechas(dates, dateStrings)}  
                             
                  />
                  
                </Modal.Content>
                <Modal.Actions>
                    <Button basic color='red' onClick={()=>this.closeModal()}>
                        <Icon name='remove' /> No
                    </Button>
                    <Button color='green' onClick={()=>this.closeModal()} >
                        <Icon name='checkmark' /> Si
                      </Button>
                </Modal.Actions>
              </Modal>
                
                
         </Segment>
		);
	}
}

//showTime={{
                    //defaultValue: [moment('09:00:00', 'HH:mm:ss'), moment('10:00:00', 'HH:mm:ss')]
                    //defaultValue: [moment('09:00:00', 'HH:mm:ss'), moment('10:00:00')]        
                  //}}

function mapStateToProps(state, ownProps, match ){  
    return {        
        tablas:state.tablas,
    }

}

function mapDispatchToProps(dispatch){

	return {   
        tablasActions: bindActionCreators(tablasActions, dispatch)
	};
}

export default connect (mapStateToProps, mapDispatchToProps)(ManageTabla);
 